import { FC } from 'react';

import { SetScreenType } from 'src/components/Modals/TemplateGallery/index';
import { TemplateGalleryTemplate } from 'src/components/Modals/TemplateGallery/components/Template';
import { TemplateGalleryMostUsedListItemType } from 'src/models/Modals/templateGallery';

type Props = {
  setScreen: SetScreenType;
  items: TemplateGalleryMostUsedListItemType[];

  smallIcons?: boolean;
};

export const TemplateGalleryTemplatesList: FC<Props> = ({ setScreen, items, smallIcons }) => (
  <>
    {items.map(({ ...item }) => (
      <TemplateGalleryTemplate
        key={item.ID}
        onClick={() => setScreen('details', item.Url)}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...item}
        small={smallIcons}
      />
    ))}
  </>
);
